export const CONFIG = {
  LEVEL_COLLECTION: "levelV8",
  COLLECTION_V1: "V1",
  COLLECTION_V2: "V2",
  FIREBASE_REGION: "europe-west3",
};
